"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _MockPrintRadioButton = _interopRequireDefault(require("./MockPrintRadioButton"));
var _HBRadioButton = require("./HBRadioButton.styles");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var HBRadioButton = function HBRadioButton(_ref) {
  var value = _ref.value,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? String(value).replace(/ /g, '_') : _ref$id,
    name = _ref.name,
    testIdName = _ref.testIdName,
    testId = _ref.testId,
    checked = _ref.checked,
    disabled = _ref.disabled,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    customTheme = _ref.customTheme,
    onChange = _ref.onChange,
    className = _ref.className,
    onBlur = _ref.onBlur,
    tabIndex = _ref.tabIndex;
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName || id || name,
    suffix: 'radio-button',
    componentName: 'HBRadioButton'
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_HBRadioButton.RadioButton, {
    isDisabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_HBRadioButton.Input, {
    type: "radio",
    id: id,
    name: name,
    value: value,
    radioSize: size,
    disabled: disabled,
    checked: checked,
    "aria-checked": checked,
    customTheme: customTheme,
    onChange: onChange,
    className: className,
    onBlur: onBlur,
    "data-testid": finalTestId,
    tabIndex: tabIndex
  })), /*#__PURE__*/_react["default"].createElement(_MockPrintRadioButton["default"], {
    size: size,
    color: customTheme === null || customTheme === void 0 ? void 0 : customTheme.background,
    checked: checked
  }));
};
var _default = exports["default"] = HBRadioButton;
//# sourceMappingURL=HBRadioButton.js.map